<template>
  <div class="right-container">
    <div class="right-header flex-between">
      <div class="flex-row-start">
        <a
          href="javascript:;"
          class="sign column"
          :class="{ active: classType == 'list' }"
          @click="onSelectType('list')"
          >班级列表</a
        >
        <a
          href="javascript:;"
          class="sign column"
          :class="{ active: classType == 'edit' }"
          @click="onSelectType('edit')"
          >添加班级</a
        >
      </div>
      <div class="flex-row-end">
        <div class="circle"></div>
        <div class="right-header-text">
          当前班级数：<span class="num">{{ pageTotal }}</span>
        </div>
        <div class="right-header-text">
          生效中：<span class="num">{{ statusTotal }}</span>
        </div>
        <div class="right-header-text">
          待生效：<span class="num">{{ pageTotal - statusTotal }}</span>
        </div>
        <div class="right-header-text">
          还可创建：<span class="num">{{ maxNum }}</span>
        </div>
      </div>
    </div>
    <template v-if="classType == 'edit'">
      <edit-class
        ref="createClassRef"
        :form="form"
        @submitCallBack="onSubmitCallBack"
      ></edit-class>
    </template>
    <!-- 班级列表 -->
    <template v-if="classType == 'list'">
      <div class="right-main  right-main-list" v-if="isNull">
        <GeminiScrollbar class="class-list-container">
          <div class="item-box " v-for="(item, index) in listData" :key="index">
            <div class="item flex-between">
              <a
                href="javascript:;"
                class="item-font-box"
                @click="onOperation(item)"
              >
                <div>
                  <span class="title">班级名称：</span>
                  <span class="info w-ellipsis">{{ item.name }}</span>
                </div>
                <div href="javascript:;">
                  <span class="title">编号：</span>
                  <span class="info w-ellipsis">{{ item.class_code }}</span>
                </div>
                <div href="javascript:;">
                  <span class="title">学生数：</span>
                  <span class="info w-ellipsis">{{ item.student_num }}</span>
                </div>
                <div href="javascript:;">
                  <span class="title">创建时间：</span>
                  <span class="info">{{ item.create_time_string }}</span>
                </div>
              </a>
              <div>
                <el-switch
                  v-model="item.status"
                  active-color="#73DB9B"
                  inactive-color="#A1AEC5"
                  :active-value="1"
                  :inactive-value="0"
                  @change="onStatus(item.class_code, item.status)"
                >
                </el-switch>
              </div>
            </div>
            <div class="operation flex-row-end" v-show="item.isShow">
              <el-button type="primary" @click="onUpdateClassInfo(item)"
                >修改基础信息</el-button
              >
              <el-button type="primary" @click="onStudentList(item)"
                >编辑学生列表</el-button
              >
              <el-button type="danger" @click="onDelete(item.class_code)"
                >删除班级</el-button
              >
            </div>
          </div>
        </GeminiScrollbar>
        <div class="list-page">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="query.page"
            :page-size="query.pageSize"
            :total="pageTotal"
            @current-change="handlePageChange"
          >
          </el-pagination>
        </div>
      </div>
      <div class="right-main  right-main-list column" v-else>
        <img src="../../assets/images/list_null.png" alt="" srcset="" />
        <div class="null">暂无数据~~</div>
      </div>
    </template>
    <el-dialog
      class="dialogClass"
      :title="dialogClass.title"
      :visible.sync="dialogClass.status"
      width="895px"
    >
      <edit-class
        ref="updateClassRef"
        :form="form"
        @submitCallBack="onSubmitCallBack"
      ></edit-class>
    </el-dialog>
    <el-dialog
      class="dialogStudent"
      :title="dialogStudent.title"
      :visible.sync="dialogStudent.status"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="980px"
    >
      <div class="student-header flex-between">
        <div class="flex-row student-item">
          <el-input
            v-model="searchPhone"
            placeholder="请输入手机号"
            class="student-input"
          ></el-input>
          <el-button type="primary" @click="onSearchPhone"
            >搜索并跳转</el-button
          >
        </div>
        <div class="flex-row student-item">
          <el-input
            v-model="pageMessage"
            placeholder="输入备注"
            class="student-input"
          ></el-input>
          <el-button type="primary" @click="onMessage">保存/覆盖</el-button>
        </div>
      </div>
      <el-table
        :data="studentList"
        class="table"
        ref="multipleTable"
        :show-header="false"
        size="mini"
        stripe
        header-cell-class-name="table-header"
      >
        <el-table-column width="50">
          <template slot-scope="scope">
            <img
              :src="scope.row.user_info.u_img"
              class="student-top-img"
              alt=""
            />
          </template>
        </el-table-column>
        <el-table-column prop="account_name" width="150"></el-table-column>
        <el-table-column prop="qp_uid" width="150" v-if="isCanpoint">
          <template slot-scope="scope">
            <div>学堂ID：{{ scope.row.user_info.qp_uid || "暂无绑定" }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="user_info.u_name" v-else>
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.user_info.u_name"
              placeholder="学生真实姓名"
              @blur="onUserName(scope.row.u_guid, scope.row.user_info.u_name)"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="user_info.mobile">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.user_info.mobile"
              placeholder="学生手机号"
              @blur="onUserMobile(scope.row.u_guid, scope.row.user_info.mobile)"
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column prop="create_time" width="210"></el-table-column>

        <el-table-column width="70" prop="is_use">
          <template slot-scope="scope">
            <a
              href="javascript:;"
              v-if="scope.row.is_use == 0"
              class="color-9"
              title="点击使用"
              @click="onStudentUse(scope.row)"
              >未使用</a
            >
            <span class="c-40b8ee" v-else>已使用</span>
          </template>
        </el-table-column>
        <el-table-column width="70">
          <!-- <el-button
              type="text"
              icon="el-icon-setting"
              @click="onSetting(scope.row)"
              title="设置学段学科"
              >设置</el-button
            > -->
          <el-dropdown @command="onSetting" slot-scope="scope">
            <span class="el-dropdown-link">
              设置<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="{ type: 1, item: scope.row }"
                >设置学科</el-dropdown-item
              >
              <el-dropdown-item :command="{ type: 2, item: scope.row }"
                >修改详情</el-dropdown-item
              >
              <el-dropdown-item
                :command="{ type: 3, item: scope.row }"
                v-if="isCanpoint"
                >绑定学堂ID号</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </el-table-column>
        <el-table-column prop="user_info.u_status" width="50">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.user_info.u_status"
              :active-value="0"
              :inactive-value="1"
              @change="
                onUserStatus(scope.row.u_guid, scope.row.user_info.u_status)
              "
            >
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination flex-between">
        <div class="sgin-box">
          <div>创建时间：{{ classIng.create_time_string }}</div>
          <div>
            班级空位情况：{{ useNum }}/{{ classStudentCount }}（余{{
              classStudentCount - useNum
            }}）
          </div>
        </div>
        <div class="flex-between">
          <div class="flex-between go-page">
            <el-input
              placeholder="页码"
              v-model="pageNum"
              class="input-page"
              size="mini"
              :min="1"
            ></el-input>
            <el-button
              type="primary"
              icon="el-icon-right"
              size="mini"
              @click="onGoStudentPage"
            ></el-button>
          </div>
          <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="queryStudent.page"
            :page-size="queryStudent.pageSize"
            :total="studentTotal"
            @current-change="studentPageChange"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="学段学科设置" :visible.sync="isTree" width="400px">
      <div class="tree-section">
        <el-tree
          ref="tree"
          :data="treeList"
          show-checkbox
          node-key="code"
          :props="treeProps"
        >
        </el-tree>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isTree = false">取 消</el-button>
        <el-button type="primary" @click="setUserStageSubject">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改学生详情" :visible.sync="isUserEdit" width="600px">
      <el-form :model="uForm">
        <el-form-item label="姓名" label-width="120px">
          <el-input
            v-model="uForm.name"
            class="u_input"
            placeholder="学生真实姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="预设到期时间" label-width="120px">
          <el-date-picker
            class="u_input"
            v-model="uForm.times"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isUserEdit = false">取 消</el-button>
        <el-button type="primary" @click="onSubmitUserInfo">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { classCode } from "@/config/common";
import "@/assets/css/upload.css";
import "@/assets/css/dialog.css";
import { mapState } from "vuex";
import EditClass from "../template/EditClass.vue";
export default {
  components: {
    EditClass,
  },
  data() {
    return {
      query: {
        page: 1,
        pageSize: 5,
      },
      queryStudent: {
        page: 1,
        pageSize: 5,
      },
      searchPhone: "",
      studentListPage: "",
      isNull: true,
      studentList: [],
      studentTotal: 0,
      classStudentCount: 0,
      dialogClass: { status: false, title: "修改基础信息" },
      dialogStudent: { status: false, title: "学生列表" },
      pageTotal: 0,
      statusTotal: 0,
      goStudentPage: "",
      pageMessage: "",
      pageNum: "",
      pageCode: "",
      useNum: 0,
      form: {},
      classType: "list",
      listData: [],
      maxNum: 0,
      treeList: [],
      treeProps: {
        children: "children",
        label: "name",
      },
      isTree: false,
      classIng: {},
      isUserEdit: false,
      uForm: {},
      isCanpoint: false,
    };
  },
  created() {
    this.getIsCanpoint();
    this.getClassNum();
    this.getList();
    this.getValidityUserStageSubject();
  },
  computed: {
    ...mapState(["user"]),
  },
  methods: {
    getIsCanpoint() {
      this.getRequest("/wenjiaoopne/kc/user/isCanpoint")
        .then((result) => {
          this.isCanpoint = result.data;
        })
        .catch(() => {});
    },
    // 获取老师建班级最大数
    getClassNum() {
      this.getRequest("/wenjiaoopne/kc/class/getMaxNum").then((result) => {
        this.maxNum = result.data;
      });
    },
    // 获取班级列表
    getList() {
      this.onLoading();
      this.getRequest("/wenjiaoopne/kc/class/list", this.query)
        .then((result) => {
          this.loading.close();
          this.listData = result.data.list;
          this.statusTotal = result.data.status_total;
          this.pageTotal = result.data.page_total;
          this.isNull = this.listData.length > 0;
        })
        .catch(() => {
          this.loading.close();
        });
    },
    getValidityUserStageSubject() {
      this.getRequest("/wenjiaoopne/kc/user/getValidityStageSubject")
        .then((result) => {
          this.treeList = result.data;
        })
        .catch(() => {});
    },
    getClassStudentsList(code) {
      this.onLoading();
      this.getRequest(
        "/wenjiaoopne/kc/teacher/classStudentsList",
        Object.assign(this.queryStudent, { class_code: code })
      )
        .then((result) => {
          this.loading.close();
          this.studentList = result.data.list;
          this.studentTotal = result.data.total_count;
        })
        .catch(() => {
          this.loading.close();
        });
    },
    // 修改状态
    onStatus(_code, v) {
      this.postRequest("/wenjiaoopne/kc/class/setStatus", {
        class_code: _code,
        status: v,
      })
        .then((result) => {
          if (result.data > 0) {
            this.$message.success("状态修改成功");
          }
          this.getList();
        })
        .catch(() => {});
    },
    // 切换选项卡触发事件
    onSelectType(v) {
      this.classType = v;
      if (v === "edit") {
        this.form = {
          id: 0,
          class_code: classCode(2, this.user.u_guid),
          province_code: "",
          city_code: "",
          area_code: "",
          name: "",
          class_img: "",
          num: 1,
        };
      }
    },
    // 点击列表触发事件
    onOperation(item) {
      this.$set(item, "isShow", !item.isShow || false);
    },
    // 删除班级
    onDelete(_code) {
      // 二次确认删除
      this.$confirm("确定要删除吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          this.postRequest("/wenjiaoopne/kc/class/delete", {
            class_code: _code,
          })
            .then((result) => {
              if (result.data > 0) {
                this.$message.success("删除成功");
              }
              this.getList();
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    getStudentList() {
      this.getRequest(
        "/wenjiaoopne/kc/teacher/classStudentsList",
        Object.assign(this.queryStudent, {
          phone: this.searchPhone,
          class_code: this.classIng.class_code,
        })
      )
        .then((result) => {
          this.loading.close();
          this.studentList = result.data.list;
          this.studentTotal = result.data.total_count;
          this.dialogStudent.status = true;
        })
        .catch(() => {
          this.loading.close();
        });
    },
    onStudentList(item) {
      this.$set(this.queryStudent, "page", 0);
      this.searchPhone = "";
      this.classIng = item;
      this.onLoading();
      this.getRequest("/wenjiaoopne/kc/teacher/classStudentInfo", {
        class_code: this.classIng.class_code,
      })
        .then((result) => {
          this.loading.close();
          if (result.error_code > 0) {
            this.$message.error(result.message);
            return false;
          }
          this.classStudentCount = result.data.count;
          this.pageMessage = result.data.message;
          this.useNum = result.data.use_num;
          this.pageNum = result.data.page_num;
          if (this.pageNum > 0) {
            this.$set(this.queryStudent, "page", this.pageNum);
          }
          this.pageCode = result.data.user_page_code;
          this.getStudentList();
        })
        .catch(() => {
          this.loading.close();
        });
    },

    onStudentDelete(item) {
      this.$confirm("确定要删除吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          this.getRequest("/wenjiaoopne/kc/teacher/deleteClassStudents", {
            id: item.id,
          })
            .then((result) => {
              if (!result.data) {
                this.$message.success("删除成功");
                return false;
              }
              this.getClassStudentsList(item.class_code);
              this.getList();
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    onUpdateClassInfo(item) {
      this.form = item;
      this.dialogClass.status = true;
    },
    // 添加修改班级回调
    onSubmitCallBack(result) {
      if (result.error_code > 0) {
        this.$message.error(result.message);
        return false;
      }
      this.$message.success(result.message);
      this.dialogClass.status = false;
      this.classType = "list";
      this.form = {};
      this.getList();
    },
    handlePageChange(v) {
      this.$set(this.query, "page", v);
      this.getList();
    },
    studentPageChange(v) {
      this.$set(this.queryStudent, "page", v);
      this.getStudentList();
    },
    onSearchPhone() {
      if (this.searchPhone != "") {
        let reg = /^[1][1,2,3,4,5,6,7,8,9,0][0-9]{9}$/;
        if (!reg.test(this.searchPhone)) {
          this.$message.error("请输入写正确的手机号码");
          return false;
        }
      }
      this.$set(this.queryStudent, "page", 1);
      this.getStudentList();
    },
    onMessage() {
      this.postRequest("/wenjiaoopne/kc/user/page/set", {
        code: this.pageCode,
        message: this.pageMessage,
      }).then((result) => {
        if (result.error_code > 0) {
          this.$message.error(result.message);
          return false;
        }
      });
    },
    onStudentUse(item) {
      this.getRequest("/wenjiaoopne/kc/teacher/classStudentsUse", {
        id: item.id,
      })
        .then((result) => {
          if (result.data) {
            this.$message.success("设置成功");
            this.useNum = this.useNum + 1;
            this.$set(item, "is_use", 1);
          } else {
            this.$message.error("设置失败");
          }
        })
        .catch(() => {});
    },
    onGoStudentPage() {
      if (this.pageNum <= 0) {
        return;
      }
      let pageNum =
        this.studentTotal % this.queryStudent.pageSize == 0
          ? this.studentTotal / this.queryStudent.pageSize
          : Math.floor(this.studentTotal / this.queryStudent.pageSize) + 1;
      if (this.pageNum > pageNum) {
        this.$message.warning(
          "最大页码不能大于等于：" + this.queryStudent.page
        );
        return;
      }
      this.onLoading();
      this.postRequest("/wenjiaoopne/kc/user/page/set", {
        code: this.pageCode,
        page_num: this.pageNum,
      })
        .then((result) => {
          this.loading.close();
          if (result.error_code > 0) {
            this.$message.error(result.message);
            return false;
          }
          this.studentPageChange(parseInt(this.pageNum));
        })
        .catch(() => {
          this.loading.close();
        });
    },
    onUserName(guid, v) {
      if (!v) return false;
      this.postRequest("/wenjiaoopne/kc/user/setUser", {
        u_guid: guid,
        u_name: v,
      })
        .then((result) => {
          if (result.error_code > 0) {
            this.$message.error(result.message);
            return false;
          }
          this.getStudentList();
          this.$message.success(result.message);
        })
        .catch(() => {});
    },
    onUserMobile(guid, v) {
      if (!v) return false;
      let reg = /^[1][1,2,3,4,5,6,7,8,9,0][0-9]{9}$/;
      if (!reg.test(v)) {
        this.$message.error("请填写正确的手机号码");
        return false;
      }
      this.getRequest("/wenjiaoopne/kc/user/isMobile", { mobile: v })
        .then((result) => {
          if (result.error_code > 0) {
            this.$message.error(result.message);
            return false;
          }
          this.setMobile(guid, v);
        })
        .catch(() => {});
    },
    setMobile(guid, v) {
      this.postRequest("/wenjiaoopne/kc/user/setUser", {
        u_guid: guid,
        mobile: v,
      })
        .then((result) => {
          if (result.error_code > 0) {
            this.$message.error(result.message);
            return false;
          }
          this.getStudentList();
          this.$message.success(result.message);
        })
        .catch(() => {});
    },
    onUserStatus(guid, v) {
      this.postRequest("/wenjiaoopne/kc/user/setUser", {
        u_guid: guid,
        u_status: v,
      })
        .then((result) => {
          if (result.error_code > 0) {
            this.$message.error(result.message);
            return false;
          }
          this.getStudentList();
          this.$message.success(result.message);
        })
        .catch(() => {});
    },
    onSetting(obj) {
      if (obj.type === 1) {
        this.guid = obj.item.u_guid;
        this.getRequest("/wenjiaoopne/kc/user/getStageSubject", {
          u_guid: this.guid,
        })
          .then((result) => {
            this.isTree = true;
            this.$nextTick(() => {
              this.$refs.tree.setCheckedKeys(result.data);
            });
          })
          .catch(() => {});
      }
      if (obj.type === 2) {
        this.uForm = {
          u_guid: obj.item.user_info.u_guid,
          name: obj.item.user_info.u_name,
          times: obj.item.times,
        };
        this.isUserEdit = true;
      }
      if (obj.type === 3) {
        this.$prompt("请输入全品学堂ID号", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPattern: /^[1,2][0-9]{8}$/,
          inputErrorMessage: "全品学堂ID号格式不正确",
        })
          .then(({ value }) => {
            if (value === obj.item.user_info.u_account) {
              return false;
            }
            this.postRequest("/wenjiaoopne/kc/user/setCanpointAccount", {
              u_guid: obj.item.user_info.u_guid,
              qp_uid: value,
            })
              .then((result) => {
                if (result.error_code > 0) {
                  this.$message.error(result.message);
                  return false;
                }
                this.getStudentList();
                this.$message.success("修改成功");
              })
              .catch(() => {});
          })
          .catch(() => {});
      }
    },
    onSubmitUserInfo() {
      this.postRequest("/wenjiaoopne/kc/user/setUser", {
        u_guid: this.uForm.u_guid,
        u_name: this.uForm.name,
        start_time: this.uForm.times[0],
        end_time: this.uForm.times[1],
      })
        .then((result) => {
          if (result.error_code > 0) {
            this.$message.error(result.message);
            return false;
          }
          this.getStudentList();
          this.isUserEdit = false;
          this.$message.success("修改成功");
        })
        .catch(() => {});
    },
    setUserStageSubject() {
      if (!this.guid || this.guid <= 0) {
        this.$message.error("网络错误");
        return false;
      }
      let stageSubjectIds = this.$refs.tree.getCheckedKeys(true);
      this.postRequest("/wenjiaoopne/kc/user/setStageSubject", {
        u_guid: this.guid,
        stage_subject_ids: stageSubjectIds.join(),
      })
        .then((result) => {
          if (result.error_code > 0) {
            this.$message.error(result.message);
            return false;
          }
          this.isTree = false;
          this.$message.success("修改成功");
        })
        .catch(() => {});
    },
    onLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
      });
    },
  },
};
</script>
<style scoped>
.class-admin-container .right-container .right-header {
  height: 130px;
  padding-top: 2px;
}
.el-dropdown-link {
  cursor: pointer;
}
.u_input {
  width: 420px;
}
.class-admin-container .right-container .sign {
  width: 123px;
  height: 49px;
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: url("../../assets/images/3.png");
  color: #fff;
}
.class-admin-container .right-container .sign:first-child {
  margin-right: 10px;
}
.class-admin-container .right-container .active {
  background-image: url("../../assets/images/2.png");
}
.class-admin-container .right-container .right-header-text {
  color: #bcc8dd;
  margin-left: 10px;
}
.class-admin-container .right-container .num {
  display: inline-block;
  color: #40b8ee;
}

.class-admin-container .right-container .circle {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin-top: 2px;
  background-color: #40b8ee;
  vertical-align: middle;
}
.class-admin-container .right-container .right-main {
  min-height: 460px;
}
.right-main-edit {
  background-color: #f3f6fe;
}

.class-list-container {
  height: 380px;
}
.class-list-container .item-box {
  margin-bottom: 4px;
}
.class-list-container .item-box .item {
  padding: 0 20px;
  height: 70px;
  background-color: #f3f6fe;
  font-size: 14px;
}
.class-list-container .item-box .operation {
  height: 70px;
  background-color: #ffffff;
}
.item-font-box {
  padding: 20px 0;
}
.item-font-box,
.item-font-box div {
  display: inline-block;
  margin-top: 2px;
}
.class-list-container .item-box .title {
  color: #333;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.class-list-container .item-box .info {
  margin-right: 20px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #8c939d;
}
.operation-button {
  color: #fff;
  background-color: #40b8ee;
  border-color: #40b8ee;
}
.list-page {
  margin-top: 20px;
  float: right;
}
.w-ellipsis {
  width: 115px;
  color: #b04151 !important;
}
.student-top-img {
  display: block;
  margin: auto;
  width: 30px;
  height: 30px;
  border-radius: 50%;
}
.sgin-box div {
  text-align: left;
  padding: 4px 0;
}
.student-header {
  position: absolute;
  top: 15px;
  right: 40px;
}
.student-input {
  margin-right: 5px;
}
.tree-section {
  width: 100%;
  height: 200px;
  overflow-y: auto;
}
.student-item {
  margin: 0 10px;
}
.input-page {
  width: 60px;
  margin-right: 5px;
}
.pagination {
  margin-bottom: 0;
}
.go-page {
  margin-right: 30px;
}
.table {
  min-height: 250px;
}
</style>
